import { currencies } from "../../constants";

export default (value, currencyCode = null, format = true) => {
  const currency = currencies?.[currencyCode]?.symbol ?? "";
  return currency + (value / (format ? 100 : 1)).toLocaleString();
};
